import { render } from "./paginate.vue?vue&type=template&id=6bb200d0"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/paginate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bb200d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bb200d0', __exports__)) {
    api.reload('6bb200d0', __exports__)
  }
  
  module.hot.accept("./paginate.vue?vue&type=template&id=6bb200d0", () => {
    api.rerender('6bb200d0', render)
  })

}


export default __exports__